import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { ThemeProvider, ToastProvider } from '@tmov/design-system';
import { ConfigProvider } from 'antd';
import './App.less';
import pt_BR from 'antd/es/locale/pt_BR';
import ReactDependentScript from 'react-dependent-script';
import AppProvider from './hooks';
import Routes from './routes';
import { GlobalStyle } from './styles/global';

function App() {
  const [collapsed, setCollapsed] = useState(false);

  const mediaQuerys = {
    xs: useMediaQuery({ maxWidth: 576 }),
    sm: useMediaQuery({ minWidth: 577, maxWidth: 767 }),
    md: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    lg: useMediaQuery({ minWidth: 992, maxWidth: 1199 }),
    xl: useMediaQuery({ minWidth: 1200, maxWidth: 1599 }),
    xxl: useMediaQuery({ minWidth: 1600 }),
  };

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={pt_BR}
        theme={{
          token: {
            colorPrimary: 'rgb(36, 169, 93)',
            colorLink: 'rgb(36, 169, 93)',
            colorLinkHover: 'rgb(30, 143, 78)',
            colorLinkActive: 'rgb(25, 119, 65)',
            colorInfo: 'rgb(36, 169, 93)',
            borderRadius: 8,
          },
          components: {
            Form: {
              itemMarginBottom: 8,
            },
          },
        }}
      >
        <ThemeProvider>
          <GlobalStyle />
          <ToastProvider>
            <ReactDependentScript>
              <AppProvider>
                <Routes
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  mediaQuerys={mediaQuerys}
                />
              </AppProvider>
            </ReactDependentScript>
{' '}
          </ToastProvider>
        </ThemeProvider>
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
